
import { Component, Emit, Mixins } from "vue-property-decorator";
import { Getter, namespace } from "vuex-class";
import { Datetime } from "vue-datetime";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import api from "@/services/api.service";

import { UserPermissions, VueBootstrapRadioField, Region } from "@/store/types";
import { ArmDisarmState, AreaSelected } from "@/store/arm-disarm-area/types";
import { Group } from "@/store/eventqueue/types";

const ArmDisarm = namespace("armDisarm");

@Component({
	components: {
		"date-time": Datetime
	},
	validations: {
		armingOption: { required }
	}
})
export default class GroupIsDisarmedModal extends Mixins(validationMixin) {
	@Getter("getPermissions") private permissions: UserPermissions;

	@ArmDisarm.State((state: ArmDisarmState) => state.selectedGroup) private selectedGroup: Group;
	@ArmDisarm.State((state: ArmDisarmState) => state.selectedRegion) private region: Region;
	@ArmDisarm.Mutation private setGroupIsDisarmedModalVisibility: (visible: boolean) => void;

	private armingOption: string = "";
	private armUntil: string = new Date(Date.now()).toISOString();

	private get modalTitle(): string {
		return `${this.selectedGroup.title} - Disarmed`;
	}

	private handleModalHidden(): void {
		this.setGroupIsDisarmedModalVisibility(false);
	}

	private get armingOptions(): VueBootstrapRadioField[] {
		return [
			{ text: "Arm Until", value: "arm-until" },
			{ text: "Leave Armed", value: "leave-armed" }
		];
	}

	private get minimumArmingDate(): string {
		const now = new Date(Date.now());

		return now.toISOString();
	}

	private get userCanArmAreas(): boolean {
		return this.permissions.canDisarmSites || this.permissions.canDisarmSitesExtended;
	}

	@Emit("tree-updated")
	private async handleArmClicked(): Promise<AreaSelected> {
		const armUntil = this.armingOption === "arm-until" ? new Date(this.armUntil) : null;

		await api.unmaskArea(this.selectedGroup.groupID, armUntil, this.region?.url);

		return { groupID: this.selectedGroup.groupID, regionID: this.region?.regionId };
	}
}
